import { render, staticRenderFns } from "./lazyblock_cards.vue?vue&type=template&id=4d063cbe&scoped=true"
import script from "./lazyblock_cards.vue?vue&type=script&lang=js"
export * from "./lazyblock_cards.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_cards.vue?vue&type=style&index=0&id=4d063cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d063cbe",
  null
  
)

export default component.exports